import React, { useRef, useState } from 'react';
import { FaVolumeUp, FaVolumeMute } from 'react-icons/fa';

const AudioPlayer = () => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleAudioToggle = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="relative flex items-center" id="play-music">
      <button
        className="rounded-full px-4 py-2 flex items-center z-20 bg-gray-800 hover:bg-gray-700 transition"
        onClick={handleAudioToggle}
      >
        {/* Animated Wave Bars */}
        <div className="audio-player flex gap-0.5">
          {[...Array(5)].map((_, index) => (
            <span
              key={index}
              className={`w-1 bg-white rounded-sm transition-all duration-300 ${
                isPlaying
                  ? `animate-wave${index + 1}`
                  : 'h-2' // Static height when not playing
              }`}
            ></span>
          ))}
        </div>

        <div className="mx-2 text-white">|</div>

        {/* Volume Icon */}
        <div className="text-white text-lg">
          {isPlaying ? <FaVolumeUp /> : <FaVolumeMute />}
        </div>
      </button>

      {/* Audio element */}
      <audio ref={audioRef} src="/audio/sample.mp3" />
    </div>
  );
};

export default AudioPlayer;
